import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'
import { DetailsTableDataGroup } from '../models'

export interface DataGroupIconListProps {
  isFirstGroup?: boolean
}

export function DataGroupIconList({
  values,
  isFirstGroup,
  label,
  labelClassName,
}: DataGroupIconListProps & DetailsTableDataGroup) {
  return (
    <div data-testid="dataGroupIconList" className={`-mb-2 ${!isFirstGroup ? 'pt-6' : ''}`}>
      {label ? <div className={twMerge('pb-[10px]', labelClassName)}>{label}</div> : ''}
      {values?.map((item) => (
        <div key={item.label} className="inline-block pr-5 pb-2 font-bold">
          {item.icon ? (
            <FontAwesomeIcon
              data-testid="icon"
              className="text-shades-400 -ml-[6px] w-8 pr-2 text-lg"
              icon={item.icon}
            />
          ) : null}
          {item.label}
        </div>
      ))}
    </div>
  )
}
